import React, { useEffect, useRef, useState } from 'react'
import styles from "./PortalDemo.module.css";
import Book from '../icons/book';
import StoneityButton from '@/components/stoneity-button/stoneityButton';
import InputSearch from '../icons/inputSearch';
import Kanban from '../icons/kanban';
import List from '../icons/list';
import Dashboard from '../icons/dashboard';
import Calendar from '../icons/calendar';
import Comment from '../icons/comment';
import Atthacment from '../icons/atthacment';
import Clock from '../icons/clock';
import Portal from '../icons/portal';
import CommentDot from '../icons/commentDot';
import DropdownArrow from '../icons/dropdownArrow';
import Private from '../icons/private';
import Public from '../icons/public';
import Reply from '../icons/reply';
import RoutingBackArrow from '../icons/routingBackArrow';
import Folder from '../icons/folder';
import Download from '../icons/download';
import { useTranslation } from 'react-i18next';
import Service from '../icons/service';
import Change from '../icons/change';
import Image, { ImageLoaderProps } from "next/image";
import { IMAGE_DELIVERY, imageLoader } from '@/base/utils/dataHelper';
import { useRouter } from 'next/router';
import InputClose from '../icons/inputClose';
import Link from 'next/link';
import ButtonArrow from '@/pages/images/buttonArrow';

enum PortalDemoEnum {
  StepFirst,
  StepSecond,
  StepThird,
  StepFourth,
  StepFifth,
  StepSixth,
  StepSeventh,
  StepEighth,
}
enum TicketWorkspaceEnum {
  TicketWorkspaceStep1,
  TicketWorkspaceStep2,
  TicketWorkspaceStep3,
  TicketWorkspaceStep4,
  TicketWorkspaceStep5,
  TicketWorkspaceStep6,
  TicketWorkspaceStep7,
  TicketWorkspaceStep8,
  TicketWorkspaceStep9,
}

interface PortalInfoBoxProps {
  title: string;
  t?: any;
  description: string;
  arrow?: 'left' | 'right' | 'top' | 'bottom';
  customInfoBoxWrapperClass?: string
  onPrev: () => void;
  onNext: () => void;
}

interface Message {
  id: number;
  text: string;
  isMine: boolean;
  userName: string;
  userInitials: string;
  date: string;
};

interface FormInputProps {
  label: string;
  value: string;
  arrow: boolean;
  close: boolean;
  type: 'input' | 'textarea';
}

// interface ConversationStep {
//   text: string;
//   user: string;
//   state: string;
//   color: string;
// };

// const conversationPrivateSteps: ConversationStep[] = [
//   {
//     text: "1. ticket aşaması Furkan tarafından onaylandı.",
//     user: "Furkan Kara",
//     state: "Open",
//     color: "#49BE83",
//   },
//   {
//     text: "2. ticket aşaması teknik ekibe iletildi.",
//     user: "Ahmet Yılmaz",
//     state: "In Progress",
//     color: "#F2C94C",
//   },
//   {
//     text: "3. ticket aşaması test sürecinde.",
//     user: "Elif Demir",
//     state: "Testing",
//     color: "#2D9CDB",
//   },
//   {
//     text: "4. ticket aşaması tamamlandı.",
//     user: "Can Aksoy",
//     state: "Done",
//     color: "#828282",
//   },
// ];

// const conversationPublicSteps: ConversationStep[] = [
//   {
//     text: "Ticket public olarak açıldı.",
//     user: "System",
//     state: "Open",
//     color: "#56CCF2",
//   },
//   {
//     text: "Public değerlendirme sürecinde.",
//     user: "Moderator",
//     state: "Review",
//     color: "#BB6BD9",
//   },
//   {
//     text: "Public ticket kapatıldı.",
//     user: "System",
//     state: "Done",
//     color: "#BDBDBD",
//   },
// ];

const PortalInfoBox = ({ t, title, description, arrow = 'left', customInfoBoxWrapperClass, onPrev, onNext }: PortalInfoBoxProps) => {
  //const { t } = useTranslation('common');

  return (
    <div data-arrow={arrow} className={`${styles.portalStepInfoBoxWrapper} ${customInfoBoxWrapperClass ?? ""} ${styles.portalBackgroundShadow}`}>
      <div className={styles.portalStepTitle}>{title}</div>
      <div className={styles.portalStepInfoBoxText}>{description}</div>
      <div className={styles.portalStepInfoBoxButtonWrapper}>
        <StoneityButton
          buttonClass="quickTourButton"
          buttonText={t("previous")}
          buttonStyle="light"
          width={90}
          height={30}
          onClick={onPrev}
        />
        <StoneityButton
          buttonClass="quickTourButton"
          buttonText={t("next")}
          width={90}
          height={30}
          onClick={onNext}
        />
      </div>
    </div>
  )
}

const PortalDemo = (props: any) => {
  const { t } = props;
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();

  const [isPortalStep, setIsPortalStep] = useState<PortalDemoEnum>(PortalDemoEnum.StepFirst)
  const isPortalDemo = isPortalStep >= PortalDemoEnum.StepFirst && isPortalStep <= PortalDemoEnum.StepFourth;
  const isKanbanDemo = isPortalStep >= PortalDemoEnum.StepFifth && isPortalStep <= PortalDemoEnum.StepSixth;
  const isPortalMyRequestDemo = isPortalStep === PortalDemoEnum.StepSeventh || isPortalStep === PortalDemoEnum.StepEighth;

  const [isTicketConversation, setIsTicketConversation] = useState(TicketWorkspaceEnum.TicketWorkspaceStep1)

  // CONVERSATİON //

  // const conversationRef = useRef<HTMLDivElement | null>(null);
  // const [conversationType, setConversationType] = useState<"private" | "public">("public");
  // const [privateMessages, setPrivateMessages] = useState<ConversationStep[]>([]);
  // const [publicMessages, setPublicMessages] = useState<ConversationStep[]>([]);
  // const [stepIndex, setStepIndex] = useState(0);

  // const conversationMap = {
  //   private: conversationPrivateSteps,
  //   public: conversationPublicSteps,
  // };

  // const activeSteps = conversationMap[conversationType];
  // const conversationStep = activeSteps[stepIndex];
  // const isConversationFinished = privateMessages.length === conversationPrivateSteps.length && publicMessages.length === conversationPublicSteps.length;
  // const pendingSwitchRef = useRef<null | "private">(null);

  // const handleSend = () => {
  //   if (pendingSwitchRef.current) {
  //     setConversationType(pendingSwitchRef.current);
  //     setStepIndex(0);
  //     pendingSwitchRef.current = null;
  //     return;
  //   }

  //   if (!conversationStep) return;

  //   if (conversationType === "public") {
  //     setPublicMessages(prev => [...prev, conversationStep]);

  //     if (publicMessages.length + 1 === conversationPublicSteps.length) {
  //       pendingSwitchRef.current = "private";
  //     }
  //   } else {
  //     setPrivateMessages(prev => [...prev, conversationStep]);
  //   }

  //   setStepIndex(prev => prev + 1);
  // };

  // const handleNextClick = () => {
  //   if (isConversationFinished) {
  //     setIsPortalStep(PortalDemoEnum.StepSeventh);
  //     return;
  //   }
  //   handleSend();
  // };

  // const visibleConversations = conversationType === "private" ? privateMessages : publicMessages;

  // const handleReset = () => {
  //   setPublicMessages([]);
  //   setPrivateMessages([]);
  //   setConversationType("public");
  //   setStepIndex(0);
  //   pendingSwitchRef.current = null;
  // };

  // useEffect(() => {
  //   if (!conversationRef.current) return;

  //   conversationRef.current.scrollTo({
  //     top: conversationRef.current.scrollHeight,
  //     behavior: "smooth",
  //   });
  // }, [visibleConversations.length]);

  // CONVERSATİON //

  // PORTAL CONVERSATION //

  const conversationPortalRef = useRef<HTMLDivElement | null>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [currentIndexPortal, setCurrentIndexPortal] = useState(0);

  const handlePrevPortalConversation = () => {

    if (currentIndexPortal < preparedMessages.length) {
      setMessages(prev => [...prev, preparedMessages[currentIndexPortal]]);
      setCurrentIndexPortal(prev => prev + 1);
      return;
    }

    setIsPortalStep(PortalDemoEnum.StepEighth);
  };

  useEffect(() => {
    if (
      isPortalStep === PortalDemoEnum.StepSixth ||
      isPortalStep === PortalDemoEnum.StepEighth
    ) {
      setMessages([]);
      setCurrentIndexPortal(0);
    }
  }, [isPortalStep]);

  useEffect(() => {
    if (!conversationPortalRef.current) return;

    conversationPortalRef.current.scrollTo({
      top: conversationPortalRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages.length]);

  // PORTAL CONVERSATION //

  const formInputs: FormInputProps[] = [
    {
      label: "requester",
      value: "userName1",
      arrow: true,
      close: false,
      type: 'input'
    },
    {
      label: "requestType",
      value: "priceInformation",
      arrow: true,
      close: false,
      type: 'input'
    },
    {
      label: "description",
      value: "iWouldLikeToGetPriceInformation",
      arrow: false,
      close: false,
      type: 'textarea'
    },
    {
      label: "priority",
      value: "normal",
      arrow: true,
      close: false,
      type: 'input'
    },
    {
      label: "requestedDate",
      value: "requestedDatePlaceholder",
      arrow: false,
      close: true,
      type: 'input'
    },
  ];

  const preparedMessages: Message[] = [
    {
      id: 1,
      text: "youCanFindTheTechnicalServicePricing",
      isMine: false,
      userName: "userName2",
      userInitials: isLanguage === "TR" ? "SÖ" : "AH",
      date: "27.05.2026 15:50",
    },
  ];

  return (
    <>
      <div className={styles.portalDemoMain}>
        {isPortalDemo &&
          <div className={styles.portalDemoContent}>
            <div className={styles.portalDemoHeader}>
              <div className={styles.portalDemoHeaderLeft}>
                {t("yourLogo")}
              </div>
              <div className={styles.portalDemoHeaderRight}>
                <div className={styles.portalDemoHeaderTab}>{t("home")}</div>
                <div className={styles.portalDemoHeaderTab}>{t("guide")}</div>
                <div className={styles.portalDemoHeaderTab}>{t("myRequest")}</div>
                <div className={styles.portalDemoHeaderUserTab}>
                  <img src="/human-6.png" alt="" />
                  <span>{t("userProfile")}</span>
                </div>
              </div>
            </div>
            <div className={styles.portalDemoBanner}>
              <div className={styles.portalDemoBannerTextPosition}>
                <div className={styles.portalDemoBannerWelcome}>{t("howCanWeHelpText")}</div>
                <div className={styles.portalDemoBannerInputWrapper}>
                  <input className={styles.portalDemoBannerInput} type="text" placeholder='Search' readOnly />
                  <div className={styles.portalDemoBannerInputIcon}>
                    <InputSearch />
                  </div>
                </div>
              </div>
              <div className={styles.portalBannerImgWrapper}>
                {/* <img src="/portalBanner.png" alt="" /> */}
                <Image
                  src={`${IMAGE_DELIVERY}/2501b6ed-dd2e-4dd5-5e4d-8d2ed4492600`}
                  alt=""
                  width={1200}
                  height={300}
                  loader={(p: ImageLoaderProps) => imageLoader(p.src, 1200, 300)}
                />
              </div>
            </div>
            <div className={styles.portalDemoCardWrapper}>
              <div className={styles.portalDemoCard} style={{ backgroundColor: "#63B4BD" }}>
                <Service />
                {t("serviceRequest")}
              </div>
              <div className={styles.portalDemoCard} style={{ backgroundColor: "#D47040" }}>
                <Change />
                {t("changeRequest")}
              </div>
              <div className={styles.portalDemoCard} style={{ backgroundColor: "#CAA77C" }}>
                <Book />
                {t("promotedArticles")}
              </div>
            </div>
          </div>
        }
        {isKanbanDemo &&
          <div className={styles.agentDemoContent}>
            <div className={styles.agentDemoTitleWrapper}>
              {t("serviceRequest")}
              <div className={styles.kanbanDemoOnTrackWrapper}>
                <div className={styles.kanbanDemoOnTrackDot}></div>
                {t("onTrack")}
              </div>
            </div>
            <div className={styles.agentViewWrapper}>
              {t("boardView")}
              <div className={styles.agentViewTabWrapper}>
                <div className={styles.agentViewTab}>
                  <Kanban />
                  {t("kanban")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <List />
                  {t("list")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <Calendar />
                  {t("calendar")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <Dashboard />
                  {t("dashboard")}
                </div>
              </div>
            </div>
            <div className={styles.agentBottomWrapper}>
              <div className={styles.agentSearchInputWrapper}>
                <input type="text" placeholder='Ara' readOnly />
                <div className={styles.agentSearchInputIcon}>
                  <InputSearch width={"8"} height={"8"} />
                </div>
              </div>
              <div className={styles.agentFilterTab}>{t("recentUpdates")} (3)</div>
              <div className={styles.agentFilterTab}>{t("assignedToMe")}  (2)</div>
              <div className={styles.agentFilterTab}>{t("requestedByMe")} (3)</div>
              <div className={styles.agentFilterTab}>{t("pendingApprovals")} (1)</div>
            </div>
            <div className={styles.kanbanViewContent}>
              <div className={styles.kanbanBackgroundLine}></div>
              <div className={styles.kanbanWrapper}>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#02C774' }}>{t("requestSubmitted")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText1")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-1.png" alt="" />
                        SRT-9
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText2")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-7
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText3")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-2.png" alt="" />
                        SRT-6
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#FCA93D' }}>{t("requestReceived")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText4")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-5
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText5")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-2.png" alt="" />
                        SRT-2
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#6FBFF9' }}>{t("inProgress")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText6")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-3.png" alt="" />
                        SRT-3
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText7")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-5.png" alt="" />
                        SRT-4
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText8")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-5.png" alt="" />
                        SRT-8
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#FF6D60' }}>{t("waitingForUser")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText9")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-1
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText10")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-3.png" alt="" />
                        SRT-10
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#CD60FF' }}>{t("completed")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText11")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-4.png" alt="" />
                        SRT-11
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.kanbanBackgroundLine}></div>
            </div>
          </div>
        }
        {isPortalMyRequestDemo &&
          <div className={styles.portalMyRequestDemoContent}>
            <div className={`${styles.portalDemoHeader} ${styles.portalDemoHeaderShadow}`}>
              <div className={styles.portalDemoHeaderLeft}>
                {t("yourLogo")}
              </div>
              <div className={styles.portalDemoHeaderRight}>
                <div className={styles.portalDemoHeaderTab}>{t("home")}</div>
                <div className={styles.portalDemoHeaderTab}>{t("guide")}</div>
                <div className={styles.portalDemoHeaderTab}>{t("myRequest")}</div>
                <div className={styles.portalDemoHeaderUserTab}>
                  <img src="/human-6.png" alt="" />
                  <span>{t("userProfile")}</span>
                </div>
              </div>
            </div>
            <div className={styles.portalMyRequestWrapper}>
              <div className={styles.portalMyRequestTitleWrapper}>
                <div className={styles.portalMyRequestTitleIcon}>
                  <RoutingBackArrow />
                </div>
                {t("myRequest")}
              </div>
              <div className={styles.portalMyRequestBackToListWrapper}>
                <div className={styles.portalMyRequestBackToListButton}>
                  <RoutingBackArrow width={"12"} height={"12"} />
                </div>
                <span>{t("backToList")}</span>
              </div>
              <div className={styles.portalMyRequestContent}>
                <div className={styles.portalMyRequestConversationWrapper}>
                  <div className={styles.portalMyRequestConversationTop}>{t("messages")}</div>
                  <div className={styles.portalMyRequestConversationBottom}>
                    <div className={styles.portalMyRequestConversationInputWrapper}>
                      <input type="text" placeholder={t("message")} readOnly />
                      <div className={styles.portalMyRequestConversationInputSendButtonWrapper}>
                        <StoneityButton
                          buttonClass='portalMyRequestConversationInputButton'
                          buttonText={t("send")}
                          width={70}
                          height={30}
                        />
                      </div>
                    </div>
                    <div className={styles.portalMyRequestConversationAreaWrapper}>
                      <div className={styles.portalMyRequestConversationAreaOverflow}>
                        <div className={styles.portalMyRequestConversationArea}>
                          <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingRight: "calc(100% - 328px)" }}>
                            <div className={`${styles.portalMyRequestConversationCard} ${styles.portalMyRequestConversationCardArrowRight}`}>
                              <div className={styles.portalMyRequestConversationCardTop}>
                                <span>{t("userName3")}</span>
                                <div className={styles.portalMyRequestConversationCardDate}>
                                  27.05.2026 14:30
                                  <Clock />
                                </div>
                              </div>
                              <div className={styles.portalMyRequestConversationCardText}>{t("thankYouForYourPriceQuotation")}</div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardUserWrapper}>
                              {isLanguage === "TR" ? "FK" : "JC"}
                            </div>
                          </div>
                          <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingRight: "calc(100% - 328px)" }}>
                            <div className={`${styles.portalMyRequestConversationCard} ${styles.portalMyRequestConversationCardArrowRight}`}>
                              <div className={styles.portalMyRequestConversationCardTop}>
                                <span>{t("userName3")}</span>
                                <div className={styles.portalMyRequestConversationCardDate}>
                                  27.05.2026 15:36
                                  <Clock />
                                </div>
                              </div>
                              <div className={styles.portalMyRequestConversationCardText}>{t("pleaseFindAttachedTheTechnicalServicePrice")}</div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardUserWrapper}>
                              {isLanguage === "TR" ? "FK" : "JC"}
                            </div>
                          </div>
                          <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingLeft: "calc(100% - 328px)" }}>
                            <div className={styles.portalMyRequestConversationCardUserWrapper}>
                              {isLanguage === "TR" ? "SÖ" : "AH"}
                            </div>
                            <div className={styles.portalMyRequestConversationCard}>
                              <div className={styles.portalMyRequestConversationCardTop}>
                                <span>{t("userName2")}</span>
                                <div className={styles.portalMyRequestConversationCardDate}>
                                  27.05.2026 15:50
                                  <Clock />
                                </div>
                              </div>
                              <div className={styles.portalMyRequestConversationCardText}>{t("youCanFindTheTechnicalServicePricing")}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.portalMyRequestConversationStartButton}>{t("startButtonText")}</div>
                    </div>
                  </div>
                </div>
                <div className={styles.portalMyRequestDetailWrapper}>
                  <div className={styles.portalMyRequestDetailTop}>{t("requestDetail")}</div>
                  <div className={styles.portalMyRequestDetailContent}>
                    <div className={styles.portalMyRequestDetailCategory}>{t("recordSummary")}</div>
                    <div className={styles.portalMyRequestDetailContentRowWrapper}>
                      <div className={styles.portalMyRequestDetailContentRowLeft}>{t("recordNo")}</div>
                      <div className={styles.portalMyRequestDetailContentRowRight}>SRT-5</div>
                    </div>
                    <div className={styles.portalMyRequestDetailContentRowWrapper}>
                      <div className={styles.portalMyRequestDetailContentRowLeft}>{t("status")}</div>
                      <div className={styles.state} style={{ backgroundColor: "#FCA93D", fontWeight: "400" }}>
                        <span>Son aşama fırsatları</span>
                      </div>
                    </div>
                    <div className={styles.portalMyRequestDetailContentRowWrapper}>
                      <div className={styles.portalMyRequestDetailContentRowLeft}>{t("createdBy")}</div>
                      <div className={styles.portalMyRequestDetailContentRowRight}>{t("userName1")}</div>
                    </div>
                    <div className={styles.portalMyRequestDetailContentRowWrapper}>
                      <div className={styles.portalMyRequestDetailContentRowLeft}>{t("createdDate")}</div>
                      <div className={styles.portalMyRequestDetailContentRowRight}>27.05.2026</div>
                    </div>
                    <div className={styles.portalMyRequestDetailAttachmentWrapper}>
                      <div className={styles.portalMyRequestDetailAttachmentTitle}>{t("attachment")}</div>
                      <div className={styles.portalMyRequestDetailAttachmentInfo}>
                        <Folder />
                        <span>{t("priceList")}</span>
                        <Download />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <div className={styles.portalStepBackground}>
          <div className={`${styles.portalStepContent} ${styles.portalStepContentFirst} ${isPortalStep === PortalDemoEnum.StepFirst ? styles.visible : ""}`}>
            <div className={styles.portalStepTitle}>{t("portalDemoStep1Title")}</div>
            <div>{t("portalDemoStep1Text")}</div>
            <StoneityButton
              buttonClass='quickTourButton'
              buttonText={t("startTour")}
              width={150}
              height={40}
              onClick={() => setIsPortalStep(PortalDemoEnum.StepSecond)}
            />
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepStyleNone} ${styles.portalStepContentSecond} ${isPortalStep === PortalDemoEnum.StepSecond ? styles.visible : ""}`}>
            <div className={styles.portalStepContentFlex}>
              <div className={`${styles.portalStepDemoCardWrapper} ${styles.portalBackgroundShadow}`}>
                <div className={styles.portalStepDemoCard} style={{ backgroundColor: "#63B4BD" }}>
                  <Service />
                  {t("serviceRequest")}
                </div>
              </div>
              <PortalInfoBox
                title={t("serviceSelection")}
                description={t("serviceSelectionText")}
                arrow='left'
                t={t}
                onPrev={() => setIsPortalStep(PortalDemoEnum.StepFirst)}
                onNext={() => setIsPortalStep(PortalDemoEnum.StepThird)}
              />
            </div>
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepStyleNone} ${styles.portalStepContentThirdAndFourth} ${isPortalStep === PortalDemoEnum.StepThird || isPortalStep === PortalDemoEnum.StepFourth ? styles.visible : ""}`}>
            <div className={styles.portalStepContentFlex}>
              <PortalInfoBox
                title={t("serviceRequestForm")}
                description={t("serviceRequestFormText")}
                arrow='right'
                t={t}
                onPrev={() =>
                  setIsPortalStep(isPortalStep === PortalDemoEnum.StepThird ? PortalDemoEnum.StepSecond : PortalDemoEnum.StepThird)
                }
                onNext={() =>
                  setIsPortalStep(isPortalStep === PortalDemoEnum.StepThird ? PortalDemoEnum.StepFourth : PortalDemoEnum.StepFifth)
                }
              />
              <div className={`${styles.portalStepFormWrapper} ${styles.portalBackgroundShadow}`}>
                <div className={styles.portalStepFormTitle}>{t("createServiceRequest")}</div>
                <div className={styles.portalStepInputFlex}>
                  {formInputs.map((item, index) => {
                    const inputId = `portal-step-input-${index}`;
                    return (
                      <div
                        key={index}
                        className={`${styles.portalStepFormInputWrapper} ${isPortalStep === PortalDemoEnum.StepFourth ? styles.filled : ""}`}
                        style={{ transitionDelay: `${index * 0.15}s` }}
                      >
                        <label htmlFor={inputId}>{t(`${item.label}`)}</label>
                        <div className={styles.portalStepFormInput}>
                          {item.type === 'textarea' ? (
                            <textarea id={inputId} readOnly className={styles.portalTextarea} aria-label={t(`${item.label}`)} />
                          ) : (
                            <input id={inputId} type="text" readOnly aria-label={t(`${item.label}`)} />
                          )}
                          {item.type === 'textarea' ?
                            <span className={`${styles.portalStepFormInputAnimatedText} ${styles.portalStepFormInputAnimatedTextArea}`} data-text={t(`${item.value}`)} />
                            :
                            <span className={styles.portalStepFormInputAnimatedText} data-text={t(`${item.value}`)} />
                          }
                          {item.arrow &&
                            <div className={styles.portalStepFormInputIconWrapper}>
                              <DropdownArrow />
                            </div>
                          }
                          {item.close && isPortalStep === PortalDemoEnum.StepFourth &&
                            <div className={styles.portalStepFormInputIconWrapper}>
                              <InputClose />
                            </div>
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={styles.formSendButtonFlex}>
                  <StoneityButton
                    buttonClass="formSendButton"
                    buttonText={t("send")}
                    width={90}
                    height={30}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepStyleNone} ${styles.portalStepContentFifth} ${isPortalStep === PortalDemoEnum.StepFifth ? styles.visible : ""}`}>
            <div className={styles.portalStepContentFlex}>
              <div className={`${styles.kanbanCardWrapper} ${styles.portalBackgroundShadow}`}>
                <div className={`${styles.kanbanCard} ${styles.kanbanDemoCard}`}>
                  <span>{t("kanbanCardText4")}</span>
                  <div className={styles.kanbanCardBottom}>
                    <div className={styles.kanbanCardBottomLeft}>
                      <img src="/human-6.png" alt="" />
                      SRT-5
                    </div>
                    <div className={styles.kanbanCardBottomRight}>
                      <Portal />
                      <CommentDot />
                      <Atthacment />
                      <Clock />
                    </div>
                  </div>
                </div>
              </div>
              <PortalInfoBox
                title={t("agentScreen")}
                description={t("agentScreenText")}
                arrow='left'
                t={t}
                onPrev={() => setIsPortalStep(PortalDemoEnum.StepFourth)}
                onNext={() => setIsPortalStep(PortalDemoEnum.StepSixth)}
              />
            </div>
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepStyleNone} ${styles.portalStepContentTicketWorkspace} ${isPortalStep === PortalDemoEnum.StepSixth ? styles.visible : ""}`}>
            <div className={styles.portalStepContentFlex} style={{ height: "100%" }}>
              <PortalInfoBox
                title={t("recordScreen")}
                description={t("recordScreenText")}
                arrow="right"
                t={t}
                customInfoBoxWrapperClass={`${styles.customPortalStepInfoBoxWrapper}
                 ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9
                    ? styles.visibleConversation
                    : styles.hiddenConversation
                  }`}
                onPrev={() => {
                  setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep7)
                  // setIsPortalStep(PortalDemoEnum.StepFifth);
                }}
                onNext={() => {
                  setIsPortalStep(PortalDemoEnum.StepSeventh);
                }}
              />
              <div className={`${styles.ticketWorkspace} ${styles.portalBackgroundShadow}`}>
                <div className={styles.ticketWorkspaceLeft}>
                  <div className={styles.ticketWorkspaceLeftTop}>
                    {t("serviceRequest")}
                    <div className={styles.ticketWorkspaceLeftInfoWrapper}>
                      <div className={styles.ticketWorkspaceLeftInfoPrefixWrapper}>
                        <div className={styles.ticketWorkspaceLeftInfoDot}></div>
                        SRT-5
                      </div>
                      <Portal />
                    </div>
                    <div className={styles.ticketWorkspaceLeftInfoInputFlex}>
                      <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                        <label htmlFor="ticket-state-input">{t("state")}</label>
                        <div className={styles.ticketWorkspaceLeftInfoInput}>
                          <input id="ticket-state-input" type="text" readOnly aria-label={t("state")} />
                          <div className={styles.state}
                            style={{
                              backgroundColor: "#FCA93D",
                              position: "absolute",
                              top: "50%",
                              left: "0",
                              transform: "translateY(-50%)"
                            }}>
                            <span>{t("requestReceived")}</span>
                          </div>
                          <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                            <DropdownArrow />
                          </div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                        <label htmlFor="ticket-assignee-input">{t("assignee")}</label>
                        <div className={styles.ticketWorkspaceLeftInfoInput}>
                          <input id="ticket-assignee-input" type="text" readOnly aria-label={t("assignee")} />
                          <div className={styles.ticketWorkspaceLeftInfoInputUserValue}>
                            <img src="/human-1.png" alt="" />
                            <span style={{ marginTop: "1px" }}>{t("userName3")}</span>
                          </div>
                          <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                            <DropdownArrow />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.agentAreaText}>
                    <span>{t("agentFields")}</span>
                  </div>
                  {formInputs.map((item, index) => {
                    const ticketInputId = `ticket-workspace-input-${index}`;
                    return (
                      <div
                        key={index}
                        className={`${styles.portalStepFormInputWrapper} ${isPortalStep === PortalDemoEnum.StepSixth ? styles.filled : ""}`}
                        style={{ transitionDelay: `${index * 0.15}s` }}
                      >
                        <label htmlFor={ticketInputId}>{t(`${item.label}`)}</label>
                        <div className={styles.portalStepFormInput}>
                          {item.type === 'textarea' ? (
                            <textarea id={ticketInputId} readOnly className={styles.portalTextarea} aria-label={t(`${item.label}`)} />
                          ) : (
                            <input id={ticketInputId} type="text" readOnly aria-label={t(`${item.label}`)} />
                          )}
                          {item.type === 'textarea' ?
                            <span className={`${styles.portalStepFormInputAnimatedText} ${styles.portalStepFormInputAnimatedTextArea}`} data-text={t(`${item.value}`)} />
                            :
                            <span className={styles.portalStepFormInputAnimatedText} data-text={t(`${item.value}`)} />
                          }
                          {item.arrow &&
                            <div className={styles.portalStepFormInputIconWrapper}>
                              <DropdownArrow />
                            </div>
                          }
                          {item.close && isPortalStep === PortalDemoEnum.StepSixth &&
                            <div className={styles.portalStepFormInputIconWrapper}>
                              <InputClose />
                            </div>
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className={styles.ticketWorkspaceRight}>
                  <div className={styles.ticketWorkspaceRightTop}>
                    <div className={styles.ticketWorkspaceRightUserWrapper}>
                      <img src="/human-6.png" alt="" />
                      <span>{t("priceInformation")}</span>
                    </div>
                    <div className={styles.ticketWorkspaceRightUserInfoAndDate}>
                      <span>{t("createdOn")}: 27-05-2026 14:30 (Europe/Istanbul)</span>
                      <span>{t("createdBy")}: {t("userName1")}</span>
                    </div>
                  </div>

                  <div className={styles.ticketWorkspaceRightTabWrapper}>
                    <div className={`${styles.ticketWorkspaceRightTab} ${styles.selected}`}>{t("conversation")}</div>
                    <div className={styles.ticketWorkspaceRightTab}>{t("attachments")} (1)</div>
                    <div className={styles.ticketWorkspaceRightTab}>{t("history")} (1)</div>
                  </div>

                  <div className={styles.ticketWorkspaceRightButtonWrapper}>
                    {/* <div className={`${styles.ticketWorkspaceRightButton} ${conversationType === "private" ? styles.ticketWorkspaceRightButtonSelected : ""}`}>
                      <Private />
                      <span>{t("private")} (4)</span>
                    </div>
                    <div className={`${styles.ticketWorkspaceRightButton} ${conversationType === "public" ? styles.ticketWorkspaceRightButtonSelected : ""}`}>
                      <Public />
                      <span>{t("public")} (3)</span>
                    </div> */}
                    <div className={`${styles.ticketWorkspaceRightButton}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep4 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep5 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ?
                        styles.ticketWorkspaceRightButtonSelected
                        :
                        ""
                      }`}>
                      <Private />
                      <span style={{ display: "flex", gap: "2px" }}>
                        {t("private")}
                        {[TicketWorkspaceEnum.TicketWorkspaceStep6].includes(isTicketConversation) ? (
                          <span className={styles.numberWrapper}>
                            <span className={styles.numberOne}>(1)</span>
                            <span className={styles.numberTwo}>(2)</span>
                          </span>
                        ) : [
                          TicketWorkspaceEnum.TicketWorkspaceStep7,
                          TicketWorkspaceEnum.TicketWorkspaceStep8,
                          TicketWorkspaceEnum.TicketWorkspaceStep9
                        ].includes(isTicketConversation) ? (
                          <span>(2)</span>
                        ) : (
                          <span>(0)</span>
                        )}
                      </span>
                    </div>
                    <div className={`${styles.ticketWorkspaceRightButton}
                   ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep1 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep2 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ||
                        isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9 ?
                        styles.ticketWorkspaceRightButtonSelected
                        :
                        ""
                      }`}>
                      <Public />
                      <span style={{ display: "flex", gap: "2px" }}>{t("public")}
                        {[TicketWorkspaceEnum.TicketWorkspaceStep3,
                        TicketWorkspaceEnum.TicketWorkspaceStep4,
                        TicketWorkspaceEnum.TicketWorkspaceStep5,
                        TicketWorkspaceEnum.TicketWorkspaceStep6,
                        TicketWorkspaceEnum.TicketWorkspaceStep7,
                        TicketWorkspaceEnum.TicketWorkspaceStep8].includes(isTicketConversation) ? (
                          <span>(1)</span>
                        )
                          :
                          [TicketWorkspaceEnum.TicketWorkspaceStep9].includes(isTicketConversation) ? (
                            <span>(2)</span>
                          )
                            : (
                              <span>(0)</span>
                            )}
                      </span>
                    </div>
                  </div>

                  <div className={`${styles.ticketWorkspaceConversationWrapper}
                  ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep2 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep5 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ?
                      styles.ticketWorkspaceConversationCustomHeightWrapper : ""
                    }`}>
                    {/* {visibleConversations.map((item, index) => (
                      <div
                        key={index}
                        className={`${styles.ticketWorkspaceConversationCard} ${styles.ticketWorkspaceConversationCardAnimate}`}
                      >
                        <div className={styles.ticketWorkspaceConversationCardTop}>
                          <div className={styles.ticketWorkspaceConversationUserWrapper}>
                            <img src="/human-1.png" alt="" />
                            <span>{item.user}</span>
                          </div>

                          <div className={styles.ticketWorkspaceConversationStateWrapper}>
                            <span>{t("addedAt")}:</span>
                            <div
                              className={styles.state}
                              style={{ backgroundColor: item.color }}
                            >
                              <span>{item.state}</span>
                            </div>
                          </div>
                        </div>

                        <div className={styles.ticketWorkspaceConversationCardMid}>
                          <span>{item.text}</span>
                        </div>

                        <div className={styles.ticketWorkspaceConversationCardBottom}>
                          <div className={styles.replyButtonWrapper}>
                            <Reply />
                            <span>{t("reply")}</span>
                          </div>
                          <div className={styles.date}>Just now</div>
                        </div>
                      </div>
                    ))} */}

                    {/* CONVERSATİON BOX */}

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonPublic}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep1 ?
                        styles.visibleConversation
                        :
                        styles.hiddenConversation
                      }`}
                    >
                      <div data-arrow={"right"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("customerCommunication")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("theAgentCanViewRequest")}</div>
                        <div className={styles.portalStepInfoBoxButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep1)
                              setIsPortalStep(PortalDemoEnum.StepFifth);
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep2) }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonConversationInput}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep2 ?
                        styles.visibleConversation
                        :
                        styles.hiddenConversation
                      }`}>
                      <div data-arrow={"bottom"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("replyCustomer")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("youCanRespondDirectly")}</div>
                        <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep1)
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep3) }}
                          />
                        </div>
                      </div>
                    </div>

                    <>
                      {/* <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonPrivate}
                      ${styles.portalStepInfoBoxTicketWorkspaceCustomPosition}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ?
                          styles.visibleConversation
                          :
                          styles.hiddenConversation
                        }`}
                      >
                        <div data-arrow={"right"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                          <div className={styles.portalStepTicketWorkspaceTitle}>{t("privateMessaging")}</div>
                          <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("privateMessagingText")}</div>
                          <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                            <StoneityButton
                              buttonClass="quickTourButton"
                              buttonText={t("previous")}
                              buttonStyle="light"
                              width={90}
                              height={30}
                              onClick={() => {
                                setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep2)
                              }}
                            />
                            <StoneityButton
                              buttonClass="quickTourButton"
                              buttonText={t("next")}
                              width={90}
                              height={30}
                              onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep4) }}
                            />
                          </div>
                        </div>
                      </div> */}
                      {/* <div className={`${styles.ticketWorkspaceConversationPrivateButtonPositon}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ?
                          styles.ticketWorkspaceConversationPrivateButtonPositonActive
                          :
                          ""
                        }`}>
                        <div className={styles.ticketWorkspaceConversationButtonPrevWrapper} onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep2) }}>
                          <ButtonArrow rotate={'180deg'} fill={'#00323D'} />
                          <span>{t("previous")}</span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationPrivateButton} onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep4) }}>
                          <Private />
                          <span>{t("private")} (2)</span>
                        </div>
                      </div> */}
                    </>

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonPrivate}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ?
                        styles.visibleConversation
                        :
                        styles.hiddenConversation
                      }`}
                    >
                      <div data-arrow={"right"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("ınterTeamCommunication")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("yourTeamCanCommunicate")}</div>
                        <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep2)
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep5) }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonConversationInput}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep5 ?
                        styles.visibleConversation
                        :
                        styles.hiddenConversation
                      }`}>
                      <div data-arrow={"bottom"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("customerCommunication")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("conversationsBetweenYourTeams")}</div>
                        <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep3)
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep6) }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonConversationInput}
                    ${styles.portalStepInfoBoxTicketWorkspacePositonConversationInputCustomPosition}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ?
                        styles.visibleCustomConversation
                        :
                        styles.hiddenCustomConversation
                      }`}>
                      <div data-arrow={"right"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("customerCommunication")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("nowTimeToShare")}</div>
                        <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep5)
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep7) }}
                          />
                        </div>
                      </div>
                    </div>

                    <>
                      {/* <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonPublic}
                    ${styles.portalStepInfoBoxTicketWorkspaceCustomPosition}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ?
                          styles.visibleConversation
                          :
                          styles.hiddenConversation
                        }`}
                      >
                        <div data-arrow={"right"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                          <div className={styles.portalStepTicketWorkspaceTitle}>{t("customerCommunication")}</div>
                          <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("publicMessagingText")}</div>
                          <div className={styles.portalStepInfoBoxButtonWrapper}>
                            <StoneityButton
                              buttonClass="quickTourButton"
                              buttonText={t("previous")}
                              buttonStyle="light"
                              width={90}
                              height={30}
                              onClick={() => {
                                setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep6)
                              }}
                            />
                            <StoneityButton
                              buttonClass="quickTourButton"
                              buttonText={t("next")}
                              width={90}
                              height={30}
                              onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep8) }}
                            />
                          </div>
                        </div>
                      </div> */}
                      {/* <div className={`${styles.ticketWorkspaceConversationPublicButtonPositon}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ?
                        styles.ticketWorkspaceConversationPublicButtonPositonActive
                        :
                        ""
                      }`}>
                      <div className={styles.ticketWorkspaceConversationButtonPrevWrapper} onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep6) }}>
                        <ButtonArrow rotate={'180deg'} fill={'#00323D'} />
                        <span>{t("previous")}</span>
                      </div>
                      <div className={styles.ticketWorkspaceConversationPublicButton} onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep8) }}>
                        <Public />
                        <span>{t("public")} (2)</span>
                      </div>
                    </div> */}
                    </>

                    <div className={`${styles.portalStepInfoBoxTicketWorkspacePositonConversationInput}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ?
                        styles.visibleConversation
                        :
                        styles.hiddenConversation
                      }`}>
                      <div data-arrow={"bottom"} className={`${styles.portalStepInfoBoxTicketWorkspaceWrapper} ${styles.portalBackgroundDarkShadow}`}>
                        <div className={styles.portalStepTicketWorkspaceTitle}>{t("customerCommunication")}</div>
                        <div className={styles.portalStepInfoBoxTicketWorkspaceText}>{t("nowTimeToInform")}</div>
                        <div className={styles.portalStepInfoBoxCustomButtonWrapper}>
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("previous")}
                            buttonStyle="light"
                            width={90}
                            height={30}
                            onClick={() => {
                              setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep6)
                            }}
                          />
                          <StoneityButton
                            buttonClass="quickTourButton"
                            buttonText={t("next")}
                            width={90}
                            height={30}
                            onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep9) }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* CONVERSATİON CONTENT */}

                    <div className={`${styles.ticketWorkspaceConversationCard}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ?
                        styles.ticketWorkspaceConversationCardAnimate
                        :
                        ""
                      }`}
                      style={{
                        display:
                          isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ||
                            isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ||
                            isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9 ?
                            "block"
                            :
                            "none"
                      }}
                    >
                      <div className={styles.ticketWorkspaceConversationCardTop}>
                        <div className={styles.ticketWorkspaceConversationUserWrapper}>
                          <img src="/human-1.png" alt="" />
                          <span>{t("userName3")}</span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationStateWrapper}>
                          <span>{t("addedAt")}:</span>
                          <div className={styles.state} style={{ backgroundColor: "#FCA93D" }}><span>{t("requestReceived")}</span></div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardMid}>
                        <span className={styles.typewriter}>
                          {t("thankYouForYourPriceQuotation")}
                        </span>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardBottom}>
                        <div className={styles.replyButtonWrapper}>
                          <Reply />
                          <span>{t("reply")}</span>
                        </div>
                        <div className={styles.date}>{t("3minutesAgo")}</div>
                      </div>
                    </div>

                    <div className={`${styles.ticketWorkspaceConversationCard}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ?
                        styles.ticketWorkspaceConversationCardAnimate
                        :
                        ""
                      }`}
                      style={{
                        display:
                          isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ?
                            "block" : "none"
                      }}
                    >
                      <div className={styles.ticketWorkspaceConversationCardTop}>
                        <div className={styles.ticketWorkspaceConversationUserWrapper}>
                          <img src="/human-1.png" alt="" />
                          <span>{t("userName3")}</span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationStateWrapper}>
                          <span>{t("addedAt")}:</span>
                          <div className={styles.state} style={{ backgroundColor: "#6FBFF9" }}><span>{t("inProgress")}</span></div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardMid}>
                        <span className={styles.typewriter}>
                          {t("canWePreparePrice")}
                        </span>
                        {/* <span>{t("canWePreparePrice")}</span> */}
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardBottom}>
                        <div className={styles.replyButtonWrapper}>
                          <Reply />
                          <span>{t("reply")}</span>
                        </div>
                        <div className={styles.date}>{t("5minutesAgo")}</div>
                      </div>
                    </div>

                    <div className={`${styles.ticketWorkspaceConversationCard}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ?
                        styles.ticketWorkspaceConversationCardAnimateCustom
                        :
                        ""
                      }`}
                      style={{ display: isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ? "block" : "none" }}
                    >
                      <div className={styles.ticketWorkspaceConversationCardTop}>
                        <div className={styles.ticketWorkspaceConversationUserWrapper}>
                          <img src="/human-4.png" alt="" />
                          <span>{t("userName4")}</span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationStateWrapper}>
                          <span>{t("addedAt")}:</span>
                          <div className={styles.state} style={{ backgroundColor: "#FF6D60" }}><span>{t("waitingForUser")}</span></div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardMid}>
                        <span className={styles.typewriterCustom}>
                          {t("helloWeHavePreparedThePricing")}
                        </span>
                        {/* <span>{t("helloWeHavePreparedThePricing")}</span> */}
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardBottom}>
                        <div className={styles.replyButtonWrapper}>
                          <Reply />
                          <span>{t("reply")}</span>
                        </div>
                        <div className={styles.date}>{t("1minutesAgo")}</div>
                      </div>
                    </div>

                    <div className={`${styles.ticketWorkspaceConversationCard}
                    ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9 ?
                        styles.ticketWorkspaceConversationCardAnimate
                        :
                        ""
                      }`}
                      style={{ display: isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9 ? "block" : "none" }}
                    >
                      <div className={styles.ticketWorkspaceConversationCardTop}>
                        <div className={styles.ticketWorkspaceConversationUserWrapper}>
                          <img src="/human-1.png" alt="" />
                          <span>{t("userName3")}</span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationStateWrapper}>
                          <span>{t("addedAt")}:</span>
                          <div className={styles.state} style={{ backgroundColor: "#FF6D60" }}><span>{t("waitingForUser")}</span></div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardMid}>
                        <span className={styles.typewriter}>
                          {t("pleaseFindAttachedTheTechnicalServicePrice")}
                        </span>
                        {/* <span>{t("helloWeHavePreparedThePricing")}</span> */}
                      </div>
                      <div className={styles.ticketWorkspaceConversationCardBottom}>
                        <div className={styles.replyButtonWrapper}>
                          <Reply />
                          <span>{t("reply")}</span>
                        </div>
                        <div className={styles.date}>{t("1minutesAgo")}</div>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.ticketWorkspaceRightBottomWrapper}
                  ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep1 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep3 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep4 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep9 ?
                      styles.ticketWorkspaceRightBottomVisibleWrapper :
                      styles.ticketWorkspaceRightBottomHiddenWrapper
                    }`}>
                    <label htmlFor="ticket-workspace-textarea" className="sr-only">{t("message")}</label>
                    <textarea id="ticket-workspace-textarea" readOnly aria-label={t("message")}></textarea>
                    <StoneityButton
                      buttonClass='ticketWorkspaceSendButton'
                      buttonText={t("send")}
                      buttonStyle='light'
                      width={70}
                      height={26}
                    />
                  </div>

                  <div className={`${styles.ticketWorkspaceRightBottomWrapper}
                  ${isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep2 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep5 ||
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7 ?
                      styles.ticketWorkspaceRightBottomBackgroundWrapper
                      :
                      ""
                    }`}>
                    <label htmlFor="ticket-workspace-textarea-filled" className="sr-only">{t("message")}</label>
                    <textarea id="ticket-workspace-textarea-filled" value={
                      isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep2
                        ? t("thankYouForYourPriceQuotation")
                        : isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep5
                          ? t("canWePreparePrice")
                          : isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep7
                            ? t("pleaseFindAttachedTheTechnicalServicePrice")
                            : ""
                    }
                      readOnly>
                    </textarea>
                    {/* {isTicketConversation === TicketWorkspaceEnum.TicketWorkspaceStep6 &&
                      <div className={`${styles.ticketWorkspaceSendButtonWrapper} ${styles.ticketWorkspaceSendButtonWrapperActive}`}>
                        <StoneityButton
                          buttonClass='ticketWorkspaceSendButton'
                          buttonText={t("send")}
                          buttonStyle='light'
                          width={70}
                          height={26}
                          onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep7) }}
                        />
                        <div className={styles.ticketWorkspaceSendButtonPrev} onClick={() => { setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep5) }}>
                          <ButtonArrow rotate={'180deg'} fill={'#00323D'} />
                          <span style={{ marginTop: "1px" }}>{t("previous")}</span>
                        </div>
                      </div>
                    } */}
                    <StoneityButton
                      buttonClass='ticketWorkspaceSendButton'
                      buttonText={t("send")}
                      buttonStyle='light'
                      width={70}
                      height={26}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepStyleNone} ${styles.portalStepContentSeventh} ${isPortalStep === PortalDemoEnum.StepSeventh ? styles.visible : ""}`}>
            <div className={styles.portalStepContentFlex} style={{ height: "100%" }}>
              <div className={`${styles.portalMyRequestConversationWrapper} ${styles.portalBackgroundShadow}`} style={{ width: "680px" }}>
                <div className={styles.portalMyRequestConversationTop}>{t("messages")}</div>
                <div className={styles.portalMyRequestConversationBottom}>
                  <div className={styles.portalMyRequestConversationInputWrapper}>
                    <input
                      type="text"
                      readOnly
                      value={t(`${preparedMessages[currentIndexPortal]?.text || ""}`)}
                      placeholder={t("message")}
                    />
                    <div className={styles.portalMyRequestConversationInputSendButtonWrapper}>
                      <StoneityButton
                        buttonClass="portalMyRequestConversationInputButton"
                        buttonText={t("send")}
                        width={70}
                        height={30}
                      />
                    </div>
                  </div>
                  <div className={styles.portalMyRequestConversationAreaWrapper}>
                    <div className={styles.portalMyRequestConversationAreaOverflow} ref={conversationPortalRef}>
                      <div className={styles.portalMyRequestConversationArea}>
                        <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingRight: "calc(100% - 328px)" }}>
                          <div className={`${styles.portalMyRequestConversationCard} ${styles.portalMyRequestConversationCardArrowRight}`}>
                            <div className={styles.portalMyRequestConversationCardTop}>
                              <span>{t("userName3")}</span>
                              <div className={styles.portalMyRequestConversationCardDate}>
                                27.05.2026 14:30
                                <Clock />
                              </div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardText}>{t("thankYouForYourPriceQuotation")}</div>
                          </div>
                          <div className={styles.portalMyRequestConversationCardUserWrapper}>
                            {isLanguage === "TR" ? "FK" : "JC"}
                          </div>
                        </div>
                        <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingRight: "calc(100% - 328px)" }}>
                          <div className={`${styles.portalMyRequestConversationCard} ${styles.portalMyRequestConversationCardArrowRight}`}>
                            <div className={styles.portalMyRequestConversationCardTop}>
                              <span>{t("userName3")}</span>
                              <div className={styles.portalMyRequestConversationCardDate}>
                                27.05.2026 15:36
                                <Clock />
                              </div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardText}>{t("pleaseFindAttachedTheTechnicalServicePrice")}</div>
                          </div>
                          <div className={styles.portalMyRequestConversationCardUserWrapper}>
                            {isLanguage === "TR" ? "FK" : "JC"}
                          </div>
                        </div>
                        {messages.map(msg => (
                          <div
                            key={msg.id}
                            className={`${styles.portalMyRequestConversationCardWrapper} ${styles.portalMessageEnter}`}
                            style={
                              msg.isMine
                                ? { paddingRight: "calc(100% - 328px)" }
                                : { paddingLeft: "calc(100% - 328px)" }
                            }
                          >
                            {!msg.isMine && (
                              <div className={styles.portalMyRequestConversationCardUserWrapper}>
                                {msg.userInitials}
                              </div>
                            )}

                            <div className={`${styles.portalMyRequestConversationCard} ${msg.isMine ? styles.portalMyRequestConversationCardArrowRight : ""}`}>
                              <div className={styles.portalMyRequestConversationCardTop}>
                                <span>{t(`${msg.userName}`)}</span>
                                <div className={styles.portalMyRequestConversationCardDate}>
                                  {msg.date}
                                  <Clock />
                                </div>
                              </div>

                              <div className={styles.portalMyRequestConversationCardText}>
                                {t(`${msg.text}`)}
                              </div>
                            </div>

                            {msg.isMine && (
                              <div className={styles.portalMyRequestConversationCardUserWrapper}>
                                {msg.userInitials}
                              </div>
                            )}
                          </div>
                        ))}

                        {/* <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingLeft: "calc(100% - 328px)" }}>
                          <div className={styles.portalMyRequestConversationCardUserWrapper}>BÖ</div>
                          <div className={styles.portalMyRequestConversationCard}>
                            <div className={styles.portalMyRequestConversationCardTop}>
                              <span>Furkan Kara</span>
                              <div className={styles.portalMyRequestConversationCardDate}>
                                23.03.2025 14:16
                                <Clock />
                              </div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardText}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, at efficitur turpis pulvinar at. Nam sed tincidunt odio, quis lacinia nulla. </div>
                          </div>
                        </div>
                        <div className={styles.portalMyRequestConversationCardWrapper} style={{ paddingRight: "calc(100% - 328px)" }}>
                          <div className={`${styles.portalMyRequestConversationCard} ${styles.portalMyRequestConversationCardArrowRight}`}>
                            <div className={styles.portalMyRequestConversationCardTop}>
                              <span>Furkan Kara</span>
                              <div className={styles.portalMyRequestConversationCardDate}>
                                23.03.2025 14:16
                                <Clock />
                              </div>
                            </div>
                            <div className={styles.portalMyRequestConversationCardText}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, at efficitur turpis pulvinar at. Nam sed tincidunt odio, quis lacinia nulla. </div>
                          </div>
                          <div className={styles.portalMyRequestConversationCardUserWrapper}>BÖ</div>
                        </div> */}
                      </div>
                    </div>
                    <div className={styles.portalMyRequestConversationStartButton}>Başla</div>
                  </div>
                </div>
              </div>
              <PortalInfoBox
                title={t("customerFollowUp")}
                description={t("customerFollowUpText")}
                arrow="left"
                t={t}
                onPrev={() => {
                  // handleReset();
                  setIsPortalStep(PortalDemoEnum.StepSixth);
                  setIsTicketConversation(TicketWorkspaceEnum.TicketWorkspaceStep1)
                }}
                onNext={() => {
                  handlePrevPortalConversation();
                }}
              />
            </div>
          </div>

          <div className={`${styles.portalStepContent} ${styles.portalStepContentEighth} ${isPortalStep === PortalDemoEnum.StepEighth ? styles.visible : ""}`}>
            <div className={styles.portalStepTitle}>{t("tryItForFree")}</div>
            <div>{t("discoverYourServiceManagement")}</div>
            <div className={styles.portalStepContentButtonFlex}>
              <StoneityButton
                buttonClass='quickTourButton'
                buttonText='Önceki'
                buttonStyle='light'
                width={120}
                height={35}
                onClick={() => setIsPortalStep(PortalDemoEnum.StepSeventh)}
              />
              <Link href={'/try-demo'} style={{ textDecoration: "none" }}>
                <StoneityButton
                  buttonClass='quickTourButton'
                  buttonText='Ücretsiz Başla'
                  width={120}
                  height={35}
                />
              </Link>
            </div>
          </div>
        </div>
      </div >
    </>
  )
}

export default PortalDemo;
